/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Benefit_Engagement_DescInputs */

const en_home_benefit_engagement_desc = /** @type {(inputs: Home_Benefit_Engagement_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renewal reminders, loyalty offers, wellness content, and community for long-term value.`)
};

const fr_home_benefit_engagement_desc = /** @type {(inputs: Home_Benefit_Engagement_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rappels de renouvellement, offres de fidélité, contenu de bien-être et communauté pour une valeur à long terme.`)
};

/**
* | output |
* | --- |
* | "Renewal reminders, loyalty offers, wellness content, and community for long-term value." |
*
* @param {Home_Benefit_Engagement_DescInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_benefit_engagement_desc = /** @type {((inputs?: Home_Benefit_Engagement_DescInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Benefit_Engagement_DescInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_benefit_engagement_desc(inputs)
	return fr_home_benefit_engagement_desc(inputs)
});